import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import HeroSection from './HeroSection'
import WeDealsIn from './WeDealsIn'
import StatsSection from './StatsSection'
import PortalGuideB2B from './PortalGuideB2B'
import DiscoverAbasin from './DiscoverAbasin'
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";
import ProductsServices from '../Products Services/ProductsServices'


const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false, // Whether animation should happen only once - while scrolling down
      mirror: true, // Whether elements should animate out while scrolling past them
    });
  }, []);

  return (
    <div style={{ overflowX: 'hidden' }}>
        <div>
            <HeroSection/>
        </div>
        <div data-aos="fade-up">
            <ProductsServices/>
        </div>
        <div data-aos="fade-up">
            <StatsSection/>
        </div>
        <div data-aos="fade-right">
            <PortalGuideB2B/>
        </div>
        <div data-aos="fade-left">
            <DiscoverAbasin/>
        </div>
        <div data-aos="fade-up">
            <WhyChooseUs/>
        </div>
        <div data-aos="fade-in">
            <WeDealsIn/>
        </div>
    </div>
  )
}

export default Home
